import { buildStoricoClicksMock } from "../../../mocks/clickMock";

// Provider mock per click/storico click.
export const mockClickProvider = {
  storici: async (_payload) => ({
    status: 202,
    data: {
      storici: buildStoricoClicksMock(),
    },
  }),

  click: async (_payload) => ({
    status: 200,
    data: {
      statusCode: 202,
      numClickGenerati: 0,
      nomeProdotto: "mock",
    },
  }),
};

